/**
 * @generated SignedSource<<fb7a4edb967c0f4fbd4f73fcbf91cbdc>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
export type GoalScoringMode = "OKR" | "SIMPLE";
export type WorkspaceType = "GLOBAL_EXPERIENCE" | "PRODUCT";
import type { FragmentRefs } from "relay-runtime";
export type storeHomeWorkspace$data = {
  readonly activationId: string | null;
  readonly cloudId: string;
  readonly cloudName: string | null;
  readonly goalScoringMode: GoalScoringMode;
  readonly id: string;
  readonly keyPrefix: string;
  readonly name: string;
  readonly organisationId: string;
  readonly timezone: string;
  readonly type: WorkspaceType;
  readonly userIsOrgAdmin: boolean;
  readonly uuid: string;
  readonly " $fragmentType": "storeHomeWorkspace";
};
export type storeHomeWorkspace$key = {
  readonly " $data"?: storeHomeWorkspace$data;
  readonly " $fragmentSpreads": FragmentRefs<"storeHomeWorkspace">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "storeHomeWorkspace"
};

(node as any).hash = "a46a40c42ab1145db8bdc75e1e23a40f";

export default node;
